
import { Component, ModelSync, Prop, Vue, } from 'vue-property-decorator';

export interface RadioOption {
	readonly id: string;
	readonly label: string;
	readonly value: string;
	readonly disabled?: boolean;
}

@Component({
})
export default class RadioGroup extends Vue {
	@Prop({
		type: String,
		required: false,
	})
	legend!: string;

	@Prop({
		type: String,
		required: true,
	})
	groupName!: string;

	@Prop({
		type: Array,
		required: true,
	})
	options!: readonly RadioOption[];

	@Prop({
		type: Boolean,
		required: false,
	})
	anyError!: boolean;

	@ModelSync('value', 'change')
	readonly groupValue!: string;

	get hasLegendSlot() {
		return !!this.$slots.legend;
	}

	hasLabelSlot(id: string) {
		const hasStandardSlot = !!this.$slots[`label_${id}`];
		const hasScopedSlot = !!this.$scopedSlots[`label_${id}`];

		return hasStandardSlot || hasScopedSlot;
	}

	hasGenericLabelSlot() {
		// eslint-disable-next-line dot-notation
		return (!!this.$slots['label'] || !this.$scopedSlots['label']);
	}
}
